import { BrowserRouter } from "react-router-dom";
import React, { useMemo } from "react";

import { UnauthenticatedNavigator } from "./unauthenticatedNavigator";
import { useAuthentication } from "@api";
import { AuthenticatedNavigator } from "./authenticatedNavigator";
import { ProgressBar } from "primereact/progressbar";

export function AppRouter() {
  const { isAuth, load } = useAuthentication();

  const currentStack = useMemo(() => {
    if (isAuth) {
      return <AuthenticatedNavigator />;
    }

    return <UnauthenticatedNavigator />;
  }, [isAuth]);

  if (load) {
    return (
      <ProgressBar
        mode="indeterminate"
        pt={{
          value: {
            style: {
              background: "#1E40AF",
            },
          },
        }}
      />
    );
  }

  return <BrowserRouter>{currentStack}</BrowserRouter>;
}
